import * as auth from './auth';
import * as db from './db';
import * as firebase from './firebase';
import * as storage from './storage';

export {
  auth,
  db,
  firebase,
  storage,
};


// WEBPACK FOOTER //
// ./src/assets/firebase/index.js